import ExpandableFormSection from "~/components/form/Sections/ExpandableFormSection";
import Summary from "~/components/form/Sections/Summary";
import { VariableLookupText } from "~/components/form/VariableLookupText";
interface ArgoCDCommitMessageProps {
    messageSummary?: string;
    updateMessageSummary: (s: string) => void;
    messageSummaryError: string;
    messageDescription?: string;
    updateMessageDescription: (s: string) => void;
    messageDescriptionError: string;
    expandedByDefault: boolean;
    localNames?: string[];
    messageDescriptionHelp: string;
}
export function ArgoCDGitCommitMessageFormSection(props: ArgoCDCommitMessageProps) {
    return (<ExpandableFormSection errorKey="CommitMessage" title="Commit Message" summary={!!props.messageSummary ? Summary.summary(props.messageSummary) : Summary.summary("No summary provided")} help={"Provide a message for the commit to Git."} isExpandedByDefault={props.expandedByDefault}>
            <VariableLookupText localNames={props.localNames} value={props.messageSummary ?? ""} onChange={(summary) => props.updateMessageSummary(summary)} label={"Summary"} error={props.messageSummaryError} multiline={false}/>
            <VariableLookupText localNames={props.localNames} value={props.messageDescription ?? ""} onChange={(description) => props.updateMessageDescription(description)} label={"Optional description"} error={props.messageDescriptionError} multiline={true} helperText={props.messageDescriptionHelp}/>
        </ExpandableFormSection>);
}
